var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('Tabs',{},[_c('Tab',{attrs:{"label":"Open Findings"}},[_c('OpenFindings')],1),_c('Tab',{attrs:{"label":"Findings Archive"}},[_c('Archive')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }